import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Dropdown from "semantic-ui-react/dist/commonjs/modules/Dropdown";
import moment from "moment";

const displayYearMonthFormat = "YYYY年M月";

const yearMonthFormat = "YYYY-MM";

const datePickerFormat = "YYYY/MM/DD";

const dayFormat = "DD";

export class DateSelector extends React.PureComponent {
  updateYearMonth(value) {
    const oldPropDate =
      this.props.value && moment(this.props.value).startOf("day");
    let propDate = moment(this.props.value || undefined).startOf("day");
    const date = moment(value, yearMonthFormat);
    propDate.set("month", date.get("month"));
    propDate.set("year", date.get("year"));
    if (!this.props.value) {
      propDate.set("date", 1);
    }
    propDate = this.boundDate(propDate);

    if (
      !oldPropDate ||
      oldPropDate.format(datePickerFormat) !== propDate.format(datePickerFormat)
    ) {
      this.props.onUpdateValue(propDate.format(datePickerFormat));
    }
  }
  updateDay(value) {
    const oldPropDate =
      this.props.value && moment(this.props.value).startOf("day");
    let propDate = moment(this.props.value || undefined).startOf("day");
    propDate.set("date", value);
    propDate = this.boundDate(propDate);

    if (
      !oldPropDate ||
      oldPropDate.format(datePickerFormat) !== propDate.format(datePickerFormat)
    ) {
      this.props.onUpdateValue(propDate.format(datePickerFormat));
    }
  }
  boundDate(date) {
    const startDate = moment(this.props.startDate);
    const endDate = moment(this.props.endDate);
    return moment.min(endDate, moment.max(startDate, moment(date || startDate).startOf("day")));
  }
  render() {
    const startDate = moment(this.props.startDate);
    const endDate = moment(this.props.endDate);
    const propDate = this.boundDate(this.props.value);

    const monthList = [];
    for (
      let target = startDate.clone().startOf("month");
      target.isSameOrBefore(endDate);
      target.add(1, "month")
    ) {
      monthList.push({
        key: target.format(yearMonthFormat),
        value: target.format(yearMonthFormat),
        text: target.format(displayYearMonthFormat),
      });
    }
    const dayList = [];
    for (
      let target = moment.max(
        propDate.clone().startOf("month"),
        startDate.clone(),
      );
      target.get("month") === propDate.get("month") && target.isSameOrBefore(endDate);
      target.add(1, "day")
    ) {
      dayList.push({
        key: target.date(),
        value: target.date(),
        text: target.date() + "日",
      });
    }

    // 月々のお支払い方法で「口座引き落し」を選択した場合、利用開始日の変数に値がセットされないためここでセットする
    if (this.props.isBank && Number(moment(this.props.value).format(dayFormat)) < Number(dayList[0]['value'])) {
        this.updateDay(dayList[0]['value']);
    }

    return (
      <div style={{ display: "flex", "align-items": "center" }}>
        <Dropdown
          style={{ width: "150px", "margin-right": "10px" }}
          className="dropdownStyleBlock"
          value={propDate && propDate.format(yearMonthFormat)}
          placeholder="選択してください"
          inline
          options={monthList}
          onChange={(event, element) => {
            this.updateYearMonth(element.value);
          }}
        />
        <Dropdown
          style={{ width: "150px", "margin-right": "10px" }}
          className="dropdownStyleBlock"
          value={propDate && propDate.date()}
          placeholder="選択してください"
          inline
          options={dayList}
          onChange={(event, element) => {
            this.updateDay(element.value);
          }}
        />
        <DatePicker
          locale="ja"
          placeholderText="選択してください"
          dateFormat={datePickerFormat}
          dateFormatCalendar="YYYY年M月"
          minDate={startDate}
          maxDate={endDate}
          selected={propDate}
          onChange={value => this.props.onUpdateValue(value)}
          customInput={
            <span>
              <i
                style={{
                  cursor: "pointer",
                  color: "#999",
                  "font-size": "20px",
                }}
                className="fa fa-calendar-alt"
              />
            </span>
          }
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./common/DateSelector.jsx